import React from 'react';
import '../styles/Map.css';

function Map() {
  return (
    <div className="map-container">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3038.025683915649!2d-3.622700884597784!3d40.401335179368136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd422584f91801ef%3A0xac7c0aef0bcd3f76!2sC.%20Mart%C3%ADn%20Mu%C3%B1oz%20de%20las%20Posadas%2C%201C%2C%2028018%20Madrid!5e0!3m2!1ses!2ses!4v1655822847728!5m2!1ses!2ses" 
        allowFullScreen="" 
        loading="lazy"
        title="Ubicación de Ari Lashes"
      ></iframe>
    </div>
  );
}

export default Map;